import { Reveal } from "./Reveal";
import { MANIFESTO, IMAGES } from "../../lib/content";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto"
      className="relative bg-[#050505] py-28 md:py-40 scroll-mt-20"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="max-w-3xl">
          <Reveal>
            <span className="text-xs tracking-luxe uppercase text-[#d4af37]">
              The Philosophy
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-serif-lux text-4xl md:text-6xl mt-6 leading-[1.05] text-[#f5f5f0]">
              A home is not a place.
              <br />
              It is a way of{" "}
              <span className="italic gold-gradient-text">living well.</span>
            </h2>
          </Reveal>
        </div>

        <div className="mt-20 grid lg:grid-cols-2 gap-x-16 gap-y-4">
          <div className="space-y-2">
            {MANIFESTO.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.08}>
                <article className="group relative border-t border-[#d4af37]/12 py-8 md:py-10">
                  <span className="absolute -left-1 top-6 font-serif-lux text-7xl md:text-8xl text-[#d4af37]/[0.07] select-none pointer-events-none">
                    {c.no}
                  </span>
                  <div className="relative pl-2">
                    <div className="flex items-center gap-4">
                      <span className="text-xs tracking-[0.2em] text-[#d4af37]">
                        {c.no}
                      </span>
                      <h3 className="font-serif-lux text-2xl md:text-3xl text-[#f5f5f0]">
                        {c.title}
                      </h3>
                    </div>
                    <p className="mt-4 text-[#9a968c] leading-relaxed max-w-md">
                      {c.body}
                    </p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>

          <div className="relative hidden lg:block">
            <div className="sticky top-28">
              <Reveal>
                <div className="relative gold-border p-3">
                  <img
                    src={IMAGES.lawnApartments}
                    alt="Sarrgosa apartments overlooking a manicured lawn framed by the Kasauli hills"
                    className="w-full h-[560px] object-cover spotlight"
                  />
                  <div className="absolute bottom-6 left-6 right-6 glass border border-[#d4af37]/20 px-6 py-5">
                    <p className="font-serif-lux text-xl text-[#f5f5f0] italic">
                      "We designed Sarrgosa for people, not portfolios."
                    </p>
                    <p className="mt-2 text-xs tracking-[0.18em] uppercase text-[#d4af37]">
                      Diamond India Builders
                    </p>
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
